<template>
  <div>
    <custom-sidebar
      :title="title"
      :title-icon="titleIcon"
      v-model="model"
      @close="close"
      :width="isMobile ? '100%' : '580px'"
    >
      <div v-if="isActivityInfo">
        <div
          class="d-flex justify-content-between align-items-center bg-gray-light p-3 rounded shadow-sm title-container"
        >
          <div
            class="d-flex justify-content-between align-items-center pointer py-2"
            @click="collapseValue = !collapseValue"
          >
            <div
              class="custom-collapse-header-icon mr-1 rounded-circle shadow-sm text-center"
              :class="{
                'bg-orange': collapseValue,
                'bg-dark-gray': !collapseValue,
              }"
            >
              <span
                class="text-white"
                :class="{
                  'fal fa-minus': collapseValue,
                  'fal fa-plus': !collapseValue,
                }"
              ></span>
            </div>
            <span>
              Ver Información de la Actividad
            </span>
          </div>
          <!-- to-do determinate -->
          <!-- <div v-if="canEdit">
          <action-button
            variant="success btn-sm"
            type="button"
            i="fas fa-edit"
            @click="toggleEdit"
          ></action-button>
        </div> -->
        </div>
        <b-collapse v-model="collapseValue">
          <div class="p-3">
            <div class="row my-3">
              <div class="col-md-12 col-12 mb-2">
                <div class="d-flex">
                  <i class="fas fa-calendar-week text-orange mr-2 mt-1"></i>
                  <div>
                    <div class="color-secondary-6 font-14">
                      Nombre de Actividad:
                    </div>
                    {{ activity.activityName | empty }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row my-3">
              <div class="col-md-6 col-12">
                <div class="d-flex">
                  <i class="fas fa-file-alt text-orange mr-2 mt-1"></i>
                  <div>
                    <div class="color-secondary-6 font-14">
                      Tipo de Actividad:
                    </div>
                    {{ activity.activityTypeName | empty }}
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12 mb-2">
                <div class="d-flex">
                  <i class="fas fa-file-user text-orange mr-2 mt-1"></i>
                  <div>
                    <div class="color-secondary-6 font-14">
                      Número de Referido:
                    </div>
                    {{ activity?.referralNumber | empty }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row my-3">
              <div class="col-md-6 col-12">
                <div class="d-flex">
                  <i class="fas fa-file-user text-orange mr-2 mt-1"></i>
                  <div>
                    <div class="color-secondary-6 font-14">
                      Número de Cita:
                    </div>
                    {{ activity.appointmentId | appointmentFormat }}
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12 mb-2">
                <div class="d-flex">
                  <i class="fas fa-file-alt text-orange mr-2 mt-1"></i>
                  <div>
                    <div class="color-secondary-6 font-14">
                      Estatus:
                    </div>

                    <div class="d-flex align-items-center">
                      <div
                        class="dot rounded-circle mr-2"
                        :style="{ backgroundColor: activity.status?.color }"
                      ></div>
                      {{ activity.status?.name | empty }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row my-3">
              <div class="col-md-6 col-12 mb-2">
                <div class="d-flex">
                  <i class="fas fa-clock text-orange mr-2 mt-1"></i>
                  <div>
                    <div class="color-secondary-6 font-14">
                      Desde:
                    </div>
                    {{ activity.dates?.from | hour }}
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="d-flex">
                  <i class="fas fa-clock text-orange mr-2 mt-1"></i>
                  <div>
                    <div class="color-secondary-6 font-14">
                      Hasta:
                    </div>
                    {{ activity.dates?.to | hour }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row my-3">
              <div class="col-md-6 col-12">
                <div class="d-flex">
                  <i class="fas fa-calendar-alt text-orange mr-2 mt-1"></i>
                  <div>
                    <div class="color-secondary-6 font-14">
                      Fecha:
                    </div>
                    {{ activity.dates?.from | date }}
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12 mb-2">
                <div class="d-flex">
                  <i class="fas fa-location-dot text-orange mr-2 mt-1"></i>
                  <div>
                    <div class="color-secondary-6 font-14">
                      Lugar:
                    </div>
                    {{ activity.caat }}
                  </div>
                </div>
              </div>
            </div>

            <div class="my-4">
              <section-title content="Participantes" has-line />
              <div v-if="hasParticipants">
                <div
                  class="bg-light-gray rounded my-3"
                  v-for="(participant, key) in activity.participants"
                  :key="key"
                >
                  <div class="p-3">
                    <p class="font-weight-bold mb-2">
                      {{ participant.name | empty }}
                    </p>
                    <div v-if="participant.position">
                      {{ participant.position }}
                    </div>
                  </div>
                </div>
              </div>
              <custom-result-not-found
                v-else
                text="No hay participantes asociados a la cita"
              />
            </div>
          </div>
        </b-collapse>

        <div v-if="isEditing" class="mt-4">
          <div>
            <label for="reasonOfChange" class="data-label">
              Razón de Cambio de Actividad:
            </label>
            <div class="w-100">
              <button
                type="button"
                class="btn border col-12"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <div class="d-flex justify-content-between">
                  <span>{{ formModel.reasonOfChange.name }}</span>
                  <div><i class="fas fa-chevron-down"></i></div>
                </div>
              </button>
              <div class="dropdown-menu mt-2 w-90">
                <a
                  class="dropdown-item pointer"
                  v-for="item in options"
                  :key="item.name"
                  @click="() => handlerChangeReasonOfChange(item)"
                >
                  {{ item.name }}
                </a>
              </div>
            </div>
          </div>
          <validation-observer ref="form">
            <div class="mt-4">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-text-area
                  id="txtComment"
                  :maxlength="3000"
                  placeholder="Escribe un comentario"
                  label="Comentario:"
                  v-model="formModel.comments"
                  :error="errors[0]"
                  :custom-error-msg="'Este campo es requerido'"
                />
              </validation-provider>
            </div>
            <div v-if="isChangeSchedule">
              <div v-if="isChangeDate" class="mt-4">
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-date-picker
                    required
                    v-model="formModel.date"
                    :disabled-days="definedTime?.disabledDays.split(',')"
                    label="Fecha:"
                    placeholder="DD/MM/YYYY"
                    class="custom-datetime-picker-container"
                    :container-class="'w-100'"
                    :error="errors[0]"
                    :custom-error-msg="'La fecha es requerida'"
                  />
                </validation-provider>
              </div>
              <div class="mt-4">
                <div class="row">
                  <div class="col-12 col-lg-6 mb-4 mb-lg-0">
                    <validation-provider v-slot="{ errors }" rules="required">
                      <custom-time-picker
                        label="Desde:"
                        v-model="formModel.fromHour"
                        :error="errors[0]"
                        :custom-error-msg="'La hora de inicio es requerida'"
                        ref="fromHour"
                      />
                    </validation-provider>
                  </div>
                  <div class="col-12 col-lg-6">
                    <validation-provider
                      v-slot="{ errors, failedRules }"
                      :rules="`required|timeGreaterThan:${formModel.fromHour}`"
                    >
                      <custom-time-picker
                        label="Hasta:"
                        v-model="formModel.toHour"
                        :error="errors[0]"
                        :custom-error-msg="
                          failedRules['timeGreaterThan']
                            ? 'La hora de fin debe ser mayor que la hora de inicio.'
                            : 'La hora de fin es requerida.'
                        "
                      />
                    </validation-provider>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isAddParticipant">
              <div class="row ">
                <div class="col-12 mt-3">
                  <custom-auto-complete
                    v-model="participant"
                    label="Participante(s):"
                    ref="autocompleteRef"
                    placeholder="Escriba Nombre del Participante"
                    v-on="$listeners"
                    :debounce-time="2000"
                    :get-result-value="getResultValue"
                    :search="searchAutoCompleteHandler"
                    :class="'w-100'"
                    @changed="handleOnChange"
                    @submit="handleSubmit"
                  />
                </div>

                <div class="col mt-3 text-right">
                  <action-button
                    variant="success"
                    :i="`fas fa-file-plus pr-1`"
                    :disabled="participant == null || participant == undefined"
                    @click="addParticipantToList"
                  >
                    Añadir Participante
                  </action-button>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <icon-view
                    class="mt-4"
                    :has-border="false"
                    icon="fas fa-user-circle text-orange"
                    icon-size="17px"
                    variant="custom-icon-view"
                    icon-background="white"
                    title="Participantes"
                  />
                </div>
              </div>
              <div class="row p-2 pt-0">
                <div
                  class="bg-light-gray p-3 col-12 mt-2"
                  v-for="(participant, key) in activity.participants"
                  :key="'old-' + key"
                >
                  <div class="py-3">
                    <p class="font-weight-bold mb-2">
                      {{ participant.name | empty }}
                    </p>
                    <div v-if="participant.position">
                      {{ participant.position }}
                    </div>
                  </div>
                </div>
                <div
                  v-for="(participant, index) in selectedParticipantsList"
                  class="bg-light-gray p-3 col-12 mt-2"
                  :key="index"
                >
                  <div class="text-right">
                    <span
                      @click="removeParticipantFromList(participant.userId)"
                      class="cursor-pointer"
                    >
                      x
                    </span>
                  </div>
                  <strong>{{ participant.fullName }}</strong>
                  <p class="mt-2">
                    {{ participant.userName }}
                  </p>
                </div>
              </div>
            </div>
          </validation-observer>
        </div>
      </div>

      <div v-else-if="isActivityHistory">
        <activity-history :items="activityLog" />
      </div>
      <template #footer>
        <div
          v-if="isActivityInfo"
          :class="
            isMobile
              ? 'justify-content-around align-items-center'
              : 'd-flex justify-content-around align-items-center'
          "
        >
          <div>
            <div v-if="isEditing">
              <action-button
                :variant="
                  isMobile
                    ? 'outline-danger w-100 mb-2'
                    : 'outline-danger mx-2 px-5'
                "
                type="button"
                i="fas fa-times-circle"
                @click="toggleEdit"
              >
                Cancelar
              </action-button>
              <action-button
                :variant="isMobile ? 'success w-100' : 'success mx-2 px-5'"
                type="button"
                i="fas fa-save"
                @click="handlerEditEvent"
              >
                Guardar
              </action-button>
            </div>

            <div v-if="!isEditing">
              <action-button
                v-if="canCancel"
                :variant="
                  isMobile ? 'success w-100 mb-2' : 'success mx-2 fs-14'
                "
                type="button"
                i="fas fa-user-xmark"
                @click="cancelActivity"
              >
                Cancelar Actividad
              </action-button>
              <action-button
                :variant="
                  isMobile
                    ? 'outline-success w-100 mb-2'
                    : 'outline-success mx-2 fs-14'
                "
                type="button"
                i="fas fa-clock-rotate-left"
                @click="seeHistory"
              >
                Ver Historial de Actividad
              </action-button>
            </div>
          </div>
        </div>

        <div :class="'justify-content-around align-items-center'">
          <div v-if="isActivityHistory">
            <action-button
              variant="outline-success"
              type="button"
              style="width:100% !important"
              i="fa fa-arrow-circle-left"
              @click="backFromHistory"
            >
              Regresar
            </action-button>
          </div>
        </div>
      </template>
    </custom-sidebar>
  </div>
</template>
<script>
const views = Object.freeze({ ACTIVITYINFO: 1, ACTIVITYHISTORY: 2 });
import ActionButton from 'ActionButton';
import SectionTitle from 'SectionTitle';
import CustomResultNotFound from 'custom-result-not-found';
import CustomTextArea from '@quisit/custom-text-area';
import CustomDatePicker from '@/components/common/form/CustomDatePicker.vue';
import CustomSidebar from '@/components/common/CustomSidebar.vue';
import CustomTimePicker from '@/components/common/CustomTimePicker.vue';
import appointmentCalendarService from '@/services/api/appointmentcalendar.api';
import appointmentChangeReasons from '@/utils/constants/appointmentChangeReasons';
import mixAlert from '@/mixins/alert.mixin';
import appointmentStatus from '@/utils/constants/appointmentStatus';
import IconView from 'icon-view';
import { CustomAutoComplete } from '@/components/common';
import CustomDropDown from 'custom-drop-down';
import appointmentChangeReason from '@/utils/constants/appointmentChangeReason';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import ActivityHistory from './ActivityHistory';
export default {
  name: 'CalendarSidebar',
  components: {
    ActionButton,
    SectionTitle,
    CustomResultNotFound,
    CustomSidebar,
    CustomTextArea,
    CustomDatePicker,
    CustomTimePicker,
    IconView,
    CustomAutoComplete,
    ActivityHistory,
  },
  mixins: [mixAlert],
  props: {
    activity: {
      type: Object,
      required: true,
    },
    definedTime: {
      type: Object,
      default: () => null,
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    selectedView: views.ACTIVITYINFO,
    activityLog: [],
    collapseValue: true,
    isEditing: false,
    formModel: {
      reasonOfChange: {
        id: null,
        name: 'Seleccione',
      },
      comments: '',
      date: null,
      fromHour: null,
      toHour: null,
    },
    options: [],
    caat: null,
    participant: null,
    searchParticipantSnapshot: {
      data: [],
    },
    specialistsFiltered: [],
    specialistsCaatsFiltered: [],
    selectedParticipantsList: [],
  }),
  computed: {
    isActivityInfo() {
      return this.selectedView == views.ACTIVITYINFO;
    },
    isActivityHistory() {
      return this.selectedView == views.ACTIVITYHISTORY;
    },
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    canEdit() {
      return (
        this.userHasPermissions(
          'technologyassistance.calendarappointment.edit'
        ) && this.isAppointmentCoordinate
      );
    },
    canCancel() {
      return this.activity?.status?.id != appointmentStatus.CanceledDE;
    },
    hasParticipants() {
      return this.activity.participants?.length > 0;
    },
    title() {
      if (this.isActivityHistory) return 'Historial de Actividad';
      return this.isEditing ? 'Editar Actividad' : 'Información de Actividad';
    },
    titleIcon() {
      if (this.isActivityHistory) return 'fas fa-clock-rotate-left';
      return this.isEditing ? 'fas fa-edit' : 'fas fa-info-circle';
    },
    isChangeSchedule() {
      return (
        this.formModel.reasonOfChange.id ===
          appointmentChangeReasons.ScheduleChange ||
        this.formModel.reasonOfChange.id === appointmentChangeReasons.DateChange
      );
    },
    isAddParticipant() {
      return (
        this.formModel.reasonOfChange.id ===
        appointmentChangeReasons.ChangeParticipant
      );
    },
    isChangeDate() {
      return (
        this.formModel.reasonOfChange.id === appointmentChangeReasons.DateChange
      );
    },
    isAppointmentCoordinate() {
      return this.activity.status?.id === appointmentStatus.Coordinate;
    },
  },
  async mounted() {
    await this.getAppointmentChangeReasons();
  },
  methods: {
    async getActivityLog() {
      const { data } = await appointmentCalendarService.getActivityLog(
        this.activity.id
      );
      this.activityLog = data;
    },
    close() {
      this.selectedView = views.ACTIVITYINFO;
      this.isEditing = false;
      this.clear();
      this.$emit('close');
    },
    async seeHistory() {
      await this.getActivityLog();
      this.selectedView = views.ACTIVITYHISTORY;
      this.$emit('see-history');
    },
    toggleEdit() {
      this.isEditing = !this.isEditing;
      if (this.isEditing) {
        this.collapseValue = false;
      } else {
        this.clear();
      }
    },
    clear() {
      this.formModel.reasonOfChange = {
        id: null,
        name: 'Seleccione',
      };
      this.formModel.comments = '';
      this.formModel.date = null;
      this.formModel.fromHour = null;
      this.formModel.toHour = null;
      this.isEditing = false;
      this.selectedParticipantsList = [];
      this.participant = null;
    },
    handlerChangeReasonOfChange(value) {
      this.formModel.reasonOfChange = value;
    },
    async handlerEditEvent() {
      if (
        this.formModel.reasonOfChange.id ==
        appointmentChangeReason.AddParticipant
      ) {
        await this.handlerSaveAddParticipantEvent();
        return;
      }
      await this.handlerEditAppointmentEvent();
    },
    async handlerEditAppointmentEvent() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        return;
      }
      const payload = {
        appointmentId: this.activity.id,
        reasonId: this.formModel.reasonOfChange.id,
        date: this.formModel.date || this.activity.dates.from,
        timeFrom: this.formModel.fromHour,
        timeTo: this.formModel.toHour,
        comment: this.formModel.comments,
      };

      try {
        const { data } = await appointmentCalendarService.changeAppointment(
          payload
        );

        this.$emit('edit-event', data);
        this.close();
      } catch (error) {
        this.ShowToast(
          'Error',
          'Ha ocurrido editando la cita, por favor intente de nuevo.',
          'error'
        );
      }
    },
    async getAppointmentChangeReasons() {
      const {
        data,
      } = await appointmentCalendarService.getAppointmentChangeReasons();
      this.options = data;
    },
    addParticipantToList() {
      if (
        this.selectedParticipantsList.some(
          (x) =>
            (this.searchParticipantSnapshot.specialistId &&
              x.specialistId == this.searchParticipantSnapshot.specialistId) ||
            (this.searchParticipantSnapshot.userId &&
              x.userId == this.searchParticipantSnapshot.userId)
        ) ||
        this.activity.participants.some(
          (x) =>
            (this.searchParticipantSnapshot.specialistId &&
              x.specialistId == this.searchParticipantSnapshot.specialistId) ||
            (this.searchParticipantSnapshot.userId &&
              x.userId == this.searchParticipantSnapshot.userId)
        )
      ) {
        this.ShowToast(
          'Alerta',
          'El participante ya se encuentra en la lista.',
          'error'
        );
        this.clearSearchModel();
        return false;
      }
      this.selectedParticipantsList.push({
        fullName: this.searchParticipantSnapshot.fullName,
        userId: this.searchParticipantSnapshot.userId,
        atServiceId: this.searchParticipantSnapshot.atServiceId,
        company: this.searchParticipantSnapshot.company,
        userName: this.searchParticipantSnapshot.userName,
        role: this.searchParticipantSnapshot.role,
        sieId: this.searchParticipantSnapshot.sieId,
        referralId: this.searchParticipantSnapshot.referralId,
        isReferral: this.searchParticipantSnapshot.isReferral,
      });
      this.clearSearchModel();
    },
    removeParticipantFromList(userId) {
      this.selectedParticipantsList = this.selectedParticipantsList.filter(
        (x) => x.userId != userId
      );
    },
    getResultValue(result) {
      return result.fullName;
    },
    searchAutoCompleteHandler(input) {
      return new Promise((resolve) => {
        if (input.length < 4) {
          return resolve([]);
        }

        if (input == this.searchParticipantSnapshot.input) {
          return resolve(this.searchParticipantSnapshot.data);
        }
        this.searchParticipantSnapshot.input = input;
        appointmentCalendarService
          .getActivitiyParticipants(input)
          .then(({ data: response }) => {
            this.specialistsFiltered = [];
            this.searchResponse = response;

            response.forEach((element) => {
              var especialistExists = this.specialistsFiltered.some(
                (x) =>
                  x.userId == element.userId &&
                  x.specialistId == element.specialistId &&
                  x.roleId == element.roleId
              );
              if (!especialistExists) {
                this.specialistsFiltered.push({
                  fullName: element.fullName,
                  userId: element.userId,
                  atServiceId: element.atServiceId,
                  company: element.company,
                  userName: element.userName,
                  role: element.role,
                  sieId: element.sieId,
                  referralId: element.referralId,
                  isReferral: element.isReferral,
                });
              }
            });

            this.searchParticipantSnapshot.data = this.specialistsFiltered.map(
              (item) => ({
                ...item,
                fullName: item.fullName,
                sub1: item.isReferral ? item.sieId : item.userName,
                sub2: item.isReferral ? item.referralId : '',
              })
            );
            resolve(this.searchParticipantSnapshot.data);
          });
      });
    },
    backFromHistory() {
      this.isEditing = false;
      this.selectedView = views.ACTIVITYINFO;
    },
    async handleSubmit(val) {
      this.participant = val.fullName;
      this.searchParticipantSnapshot.input = val.fullName;
      this.searchParticipantSnapshot.fullName = val.fullName;
      this.searchParticipantSnapshot.role = val.role;
      this.searchParticipantSnapshot.userId = val.userId;
      this.searchParticipantSnapshot.atServiceId = val.atServiceId;
      this.searchParticipantSnapshot.company = val.company;
      this.searchParticipantSnapshot.userName = val.userName;
      this.searchParticipantSnapshot.sieId = val.sieId;
      this.searchParticipantSnapshot.referralId = val.referralId;
      this.searchParticipantSnapshot.isReferral = val.isReferral;
      this.specialistsCaatsFiltered = [];
    },
    handleOnChange(val) {
      this.participant = val.fullName;
      if (!val) {
        this.searchParticipantSnapshot.input = null;
      }
    },
    async cancelActivity() {
      const isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea cancelar la actividad ${this.activity.activityName}?`,
        'Sí',
        'No'
      );

      if (!isConfirmed) {
        return;
      }

      this.$emit('cancel-activity', this.activity);
    },
    clearSearchModel() {
      this.searchParticipantSnapshot = {
        data: [],
      };
      this.specialistsFiltered = [];
      this.caat = null;
      this.$refs.autocompleteRef.onClearHandler();
    },
    async handlerSaveAddParticipantEvent() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        return;
      }
      const payload = {
        appointmentId: this.activity.id,
        reasonId: this.formModel.reasonOfChange.id,
        participants: this.selectedParticipantsList.map((item) => ({
          userId: item.userId,
          roleId: item.roleId,
          companyId: item.companyId,
          specialistLocationId: item.specialistLocationId,
          specialistId: item.specialistId,
          caatId: item.caatId,
        })),
        comment: this.formModel.comments,
      };

      try {
        const { data } = await appointmentCalendarService.updateParticipant(
          payload
        );
        this.close();
        this.ShowToast(
          'Éxito',
          'Información ha sido guardada exitosamente.',
          'success'
        );
      } catch (error) {
        this.ShowToast(
          'Error',
          'Ha ocurrido un error añadiento participante, por favor intente de nuevo.',
          'error'
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';
.custom-collapse-header-icon {
  width: 25px;
  height: 25px;
  border: solid 1px white;
}
.custom-collapse-header-icon + span {
  font-weight: 600;
}
.bg-gray-light {
  background-color: #efefef;
}
.pointer {
  cursor: pointer;
}

.custom-mt {
  margin-top: 5rem;
}

.btn-drowdown {
  min-height: 3rem;
}

::v-deep .width-container {
  width: 100% !important;
}

.btn-sm {
  height: 40px;
  width: 40px;
}

.title-container {
  height: 50px;
}

.dot {
  padding: 0.45rem;
}

.fs-14 {
  font-size: 14px;
}
</style>
